export const CCYZ = {
    index: {
        header_2: 'Type Of Storage',
        header_3: ' Do You Require?',
    },
    unit_listing: {
        header_1: 'How Much ',
        header_2: 'Space',
        header_3: ' Do You Require?',
    },
    book_unit: {
        header_1: 'Select A ',
        header_2: 'Deal',
        header_3: ' Below',
        deals: ' Deals',
        inclusions: 'What\'s Included',
    },
    wizard: {
        scheduleMoveIn: 'Schedule Your Move-In',
        pricingTable: {
            amount: 'Amount (exc. VAT)',
            tax: 'VAT',
        },
        insuranceCoverage: {
            title: 'StoreProtect',
        },
        bookingConfirmation: {
            title: 'Thank You For Your Booking',
            pleaseWait:
        'You\'re almost there, we\'re just loading your E-sign documents. Please wait.',
            subtitle:
        'We have sent you an email with more details, please refer to the email for further information.',
        },
    },
    bookingConfirmation: {
        title: 'Thank You For Your Booking',
    },
    cta: {
        step_3: {
            continue: 'Book Now',
        },
        call_us_now:
      'This unit type currently has low availability.  Call us now and our friendly team will help find the perfect storage solution for you.',
    },
    sizeSlider: {
        small: 'Smaller',
        large: 'Larger',
    },
};
